// Global Types
import type {
  $FullWebRegatta,
} from 'common.data';
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

// Helpers
import moment from 'moment';

// Components
import RegattasListItem from '../RegattasListItem';

// Types
type $OptionalProps = {
  showFullList?: boolean;
};

type $Props = $OptionalProps & $Translate & {
  basePath: string;
  data: Array<$FullWebRegatta>;
  shortDateFormat: string;
};

type $State = {
  endedDataQuantity: null | number;
  filteredData: Array<$FullWebRegatta>;
  showEndedData: boolean;
};

const now: moment.Moment = moment();

class RegattasListView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    showFullList: undefined,
  };

  constructor(props: $Props) {
    super(props);

    let filteredData = props.data;

    if (props.showFullList === false) {
      filteredData = props.data.filter((dataItem) => moment(dataItem.EndDate)
        .add(
          2,
          'days',
        )
        .isAfter(now));
    }

    this.state = {
      endedDataQuantity: null,
      filteredData,
      showEndedData: props.showFullList || false,
    };
  }

  renderShowEndedButton() {
    const {
      data,
      t,
    } = this.props;
    const {
      filteredData,
      showEndedData,
    } = this.state;

    const endedDataQuantity: number = data.length - filteredData.length;

    return (showEndedData === false ? (
      <div className={'text-center'}>
        <button
          className={'btn btn_light btn_outlined uppercase py-1 mb-3'}
          onClick={() => this.setState({
            endedDataQuantity,
            filteredData: data,
            showEndedData: true,
          })}
          title={t('Show ended regattas')}
          type={'button'}
        >
          {`${t('Show ended regattas')} (${endedDataQuantity})`}
        </button>
      </div>
    ) : null);
  }

  renderDataItem(dataItem: $FullWebRegatta) {
    const {
      basePath,
      shortDateFormat,
      showFullList,
    } = this.props;

    return (
      <RegattasListItem
        basePath={basePath}
        item={dataItem}
        key={dataItem.id}
        opacity={moment(dataItem.EndDate).isBefore(now) && showFullList === false}
        shortDateFormat={shortDateFormat}
      />
    );
  }

  render() {
    const {
      endedDataQuantity,
      filteredData,
    } = this.state;

    return (
      <div className={'RegattasList -mb-2'}>
        {this.renderShowEndedButton()}
        {filteredData.map((dataItem, index: number) => (
          <>
            {endedDataQuantity === index && (
              <div className={'mb-2 border-t-4 border-red-400'} />
            )}
            {this.renderDataItem(dataItem)}
          </>
        ))}
      </div>
    );
  }
}

export default RegattasListView;
